"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var styles_1 = require("@mui/material/styles");
exports.default = (0, styles_1.styled)(Grid_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        alignItems: 'center',
        button: {
            opacity: 0,
            transition: 'all .15s ease-out',
            fontWeight: theme.typography.fontWeightMedium,
        },
        '&:hover button': {
            opacity: 1,
            transition: 'all .15s ease-out',
        },
    });
});
